import { CoverageTypeEnum } from '../token/types'

const appEnv = import.meta.env.MODE ?? 'development'

export const WHITELIST_LIMITS: Partial<Record<CoverageTypeEnum, number>> = {
  [CoverageTypeEnum.PRESCRIPTION]: appEnv === 'development' ? 35 : 35_000,
  [CoverageTypeEnum.LAB_WORK]: appEnv === 'development' ? 70 : 70_000,
  [CoverageTypeEnum.CONSULTATION]: appEnv === 'development' ? 25 : 25_000,
}
